import { gql } from "@apollo/client";

const GENERATE_DAF_FEES = gql`
  mutation GenerateDafFees($entityId: ID!, $quarter: Int!, $year: Int!) {
    generateDafFees(entityId: $entityId, quarter: $quarter, year: $year) {
      dafFees {
        accountMask
        advisorName
        custodian
        dafName
        arrearFee
        adminFee
      }
      date
      entityName
      quarter
      year
      productOwner {
        _id
        firstName
        lastName
      }
    }
  }
`;

const CREATE_GENERATE_DAF_FEES = gql`
  mutation CreateGenerateDafFees($entityId: ID!, $quarter: Int!, $year: Int!) {
    createGenerateDafFees(entityId: $entityId, quarter: $quarter, year: $year) {
      dafFees {
        accountMask
        advisorName
        custodian
        dafName
        arrearFee
        adminFee
      }
      date
      entityName
      quarter
      year
      productOwner {
        _id
        firstName
        lastName
      }
    }
  }
`;

const CREATE_FEE_FROM_TEMPLATE = gql`
  mutation CreateFeeFromTemplate(
    $feeType: FeeType!
    $productId: ID!
    $productName: String!
    $feeId: ID
  ) {
    createFeeFromTemplate(
      feeType: $feeType
      productId: $productId
      productName: $productName
      feeId: $feeId
    ) {
      ... on DafFee {
        _id
      }
      ... on ClatFee {
        _id
      }
    }
  }
`;

const GENERATE_DAF_FEES_PER_DONOR = gql`
  mutation GenerateDafFeesPerDonor($quarter: Int!, $userId: ID!, $year: Int!) {
    generateDafFeesPerDonor(quarter: $quarter, userId: $userId, year: $year) {
      dafFees {
        accountMask
        advisorName
        custodian
        dafName
        arrearFee
        adminFee
      }
      date
      entityName
      quarter
      year
    }
  }
`;

const GENERATE_DAF_FEES_ALL_DONOR_WITHOUT_ADVISOR = gql`
  mutation GenerateDafFeesAllDonorWithoutAdvisor($quarter: Int!, $year: Int!) {
    generateDafFeesAllDonorWithoutAdvisor(quarter: $quarter, year: $year) {
      dafFees {
        accountMask
        advisorName
        custodian
        dafName
        arrearFee
        adminFee
      }
      date
      quarter
      year
      productOwner {
        _id
        firstName
        lastName
      }
    }
  }
`;

const CREATE_GENERATE_DAF_FEES_ALL_DONOR_WITHOUT_ADVISOR = gql`
  mutation CreateGenerateDafFeesAllDonorWithoutAdvisor($quarter: Int!, $year: Int!) {
    createGenerateDafFeesAllDonorWithoutAdvisor(quarter: $quarter, year: $year) {
      dafFees {
        accountMask
        advisorName
        custodian
        dafName
        arrearFee
        adminFee
      }
      date
      quarter
      year
      productOwner {
        _id
        firstName
        lastName
      }
    }
  }
`;

const CREATE_FEE = gql`
  mutation CreateFee($args: CombinedCreateFeeInput) {
    createFee(args: $args) {
      ... on BrandingFee {
        _id
      }
    }
  }
`;

const UPDATE_FEE = gql`
  mutation UpdateFee($updateFeeId: ID!, $args: CombinedUpdateFeeInput) {
    updateFee(id: $updateFeeId, args: $args) {
      ... on ClatFee {
        _id
      }
      ... on DafFee {
        _id
      }
    }
  }
`;

export {
  GENERATE_DAF_FEES,
  CREATE_GENERATE_DAF_FEES,
  CREATE_FEE_FROM_TEMPLATE,
  GENERATE_DAF_FEES_PER_DONOR,
  GENERATE_DAF_FEES_ALL_DONOR_WITHOUT_ADVISOR,
  CREATE_FEE,
  UPDATE_FEE,
  CREATE_GENERATE_DAF_FEES_ALL_DONOR_WITHOUT_ADVISOR,
};
